import React from 'react';

import { Link } from 'gatsby';

import { useTheme } from '@mui/material';

import { ProductCardColorSlider } from '@mewa/ui';

import { ProductFallbackImage } from '../product-fallback-image';
import { ProductCardBaseData } from './product-card-base';
import { getImages, ProductImage } from './product-card-helper';

type Props<T extends ProductCardBaseData> = {
  useMbsFallbackIcon: boolean;
  product: T;
  style?: React.CSSProperties;
  className?: string;
  langPrefix: string;
  detailsPageLabel: string;
};

export const ProductCardColorSliderWrapper = React.memo(
  <T extends ProductCardBaseData>({
    useMbsFallbackIcon,
    product,
    style,
    className,
    langPrefix,
    detailsPageLabel,
  }: Props<T>) => {
    const theme = useTheme();

    return (
      <ProductCardColorSlider
        style={style}
        className={className}
        title={product.displayName}
        subtitle={product.collection?.name ?? product.modelName}
        ImageLinkComponent={Link}
        variants={product.variants.map((v) => {
          return {
            colorName: v.colorName,
            footerButtonProps: {
              component: Link,
              to: `${langPrefix}/${v.slug}`,
              children: detailsPageLabel,
            },
            imageLinkProps: {
              to: `${langPrefix}/${v.slug}`,
            },
            image: v.assetId ? (
              <ProductImage
                images={getImages(v.assetId, theme)}
                alt={product.displayName}
              />
            ) : (
              <ProductFallbackImage useMbsFallbackIcon={useMbsFallbackIcon} />
            ),
          };
        })}
      />
    );
  },
);

ProductCardColorSliderWrapper.displayName = 'SwiperSlide';
